import React from "react";

export default function OpsOverridesTab({
  overrideSearch,
  setOverrideSearch,
  overrideCompanyError,
  overrideCompanies,
  overrideCompanyLoading,
  searchOverrideCompanies,
  overrideCompany,
  selectOverrideCompany,
  overrideForm,
  handleOverrideChange,
  overrideStatus,
  overrideSaving,
  activeOverride,
  deleteOverride,
  saveOverride,
  promoRedeemCode,
  setPromoRedeemCode,
  redeemPromo,
  promoCodes,
  promoLoading,
  openPromoEditor,
  deletePromo,
  promoStatus,
  editingPromoId,
  promoForm,
  handlePromoField,
  handlePromoBenefitField,
  resetPromoForm,
  savePromo,
}) {
  return (
    <div className="ops-overrides">
      <div className="ops-overrides-panel">
        <div className="ops-overrides-header">
          <div>
            <h4>Company Overrides</h4>
            <p>Apply bespoke limits or pricing to any customer account.</p>
          </div>
        </div>
        <div className="ops-field-row">
          <input
            type="text"
            placeholder="Search company..."
            value={overrideSearch}
            onChange={(e) => setOverrideSearch(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && searchOverrideCompanies()}
          />
          <button type="button" className="btn btn-outline-primary" onClick={searchOverrideCompanies}>
            {overrideCompanyLoading ? "Searching..." : "Search"}
          </button>
        </div>
        {overrideCompanyError && <p className="text-danger small">{overrideCompanyError}</p>}
        {overrideCompanies.length > 0 && (
          <div className="ops-table-wrapper mt-2">
            <table className="ops-table compact">
              <thead>
                <tr>
                  <th>Company</th>
                  <th>Domain</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {overrideCompanies.map((company) => (
                  <tr key={company.id}>
                    <td>
                      <strong>{company.name}</strong>
                      <div className="mono-id">{company.id}</div>
                    </td>
                    <td>{company.email}</td>
                    <td>
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-primary"
                        onClick={() => selectOverrideCompany(company)}
                      >
                        Manage
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {overrideCompany && (
          <div className="ops-override-form">
            <div className="ops-overrides-header mt-3">
              <div>
                <h5>{overrideCompany.name}</h5>
                <p className="mono-id">{overrideCompany.id}</p>
              </div>
              {overrideStatus && <span className="text-success">{overrideStatus}</span>}
            </div>
            <div className="ops-two-col">
              <label>
                Custom Plan Name
                <input
                  type="text"
                  value={overrideForm.customPlanName}
                  onChange={(e) => handleOverrideChange("customPlanName", e.target.value)}
                />
              </label>
              <label>
                Expires At
                <input
                  type="datetime-local"
                  value={overrideForm.expiresAt}
                  onChange={(e) => handleOverrideChange("expiresAt", e.target.value)}
                />
              </label>
              <label>
                Device Limit
                <input
                  type="number"
                  min="0"
                  placeholder="Leave blank for plan default"
                  value={overrideForm.devicesAllowed}
                  onChange={(e) => handleOverrideChange("devicesAllowed", e.target.value)}
                />
              </label>
              <label>
                User Limit
                <input
                  type="number"
                  min="0"
                  placeholder="Leave blank for plan default"
                  value={overrideForm.usersAllowed}
                  onChange={(e) => handleOverrideChange("usersAllowed", e.target.value)}
                />
              </label>
              <label>
                SMS Quota
                <input
                  type="number"
                  min="0"
                  placeholder="Leave blank for plan default"
                  value={overrideForm.smsQuota}
                  onChange={(e) => handleOverrideChange("smsQuota", e.target.value)}
                />
              </label>
              <label>
                Voice Quota
                <input
                  type="number"
                  min="0"
                  placeholder="Leave blank for plan default"
                  value={overrideForm.voiceQuota}
                  onChange={(e) => handleOverrideChange("voiceQuota", e.target.value)}
                />
              </label>
              <label>
                Price Override (USD)
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  placeholder="Leave blank for plan price"
                  value={overrideForm.priceOverride}
                  onChange={(e) => handleOverrideChange("priceOverride", e.target.value)}
                />
              </label>
              <label>
                Discount %
                <input
                  type="number"
                  step="0.1"
                  min="0"
                  placeholder="Apply % discount"
                  value={overrideForm.discountPercent}
                  onChange={(e) => handleOverrideChange("discountPercent", e.target.value)}
                />
              </label>
            </div>
            <label className="mt-2">
              Notes
              <textarea rows={3} value={overrideForm.note} onChange={(e) => handleOverrideChange("note", e.target.value)} />
            </label>
            <div className="ops-override-actions">
              <div className="promo-redeem">
                <input
                  type="text"
                  placeholder="Apply promo code"
                  value={promoRedeemCode}
                  onChange={(e) => setPromoRedeemCode(e.target.value.toUpperCase())}
                />
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  disabled={!promoRedeemCode || overrideSaving}
                  onClick={redeemPromo}
                >
                  Apply
                </button>
              </div>
              <div className="ops-button-row">
                <button type="button" className="btn btn-primary" onClick={saveOverride} disabled={overrideSaving}>
                  {overrideSaving ? "Saving..." : "Save Override"}
                </button>
                {activeOverride && (
                  <button type="button" className="btn btn-outline-danger" onClick={deleteOverride}>
                    Remove Override
                  </button>
                )}
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="ops-overrides-panel">
        <div className="ops-overrides-header">
          <div>
            <h4>Promo Codes</h4>
            <p>Generate shareable perks that automatically create overrides on redemption.</p>
          </div>
          <button type="button" className="btn btn-outline-primary" onClick={() => openPromoEditor(null)}>
            New Promo
          </button>
        </div>
        {promoStatus && <p className="text-muted">{promoStatus}</p>}
        <div className="ops-table-wrapper">
          <table className="ops-table">
            <thead>
              <tr>
                <th>Code</th>
                <th>Usage</th>
                <th>Window</th>
                <th>Status</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {(promoCodes || []).map((promo) => (
                <tr key={promo.id}>
                  <td>
                    <strong>{promo.code}</strong>
                    <div className="mono-id">{promo.description || "No description"}</div>
                  </td>
                  <td>
                    {promo.redemption_count || 0}
                    {promo.max_redemptions ? ` / ${promo.max_redemptions}` : " (∞)"}
                  </td>
                  <td>
                    {promo.valid_from ? promo.valid_from.slice(0, 10) : "Any"} →{" "}
                    {promo.valid_until ? promo.valid_until.slice(0, 10) : "Any"}
                  </td>
                  <td>{promo.is_active ? "Active" : "Disabled"}</td>
                  <td className="d-flex gap-2 flex-wrap">
                    <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => openPromoEditor(promo)}>
                      Edit
                    </button>
                    <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => deletePromo(promo)}>
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
              {!promoLoading && promoCodes.length === 0 && (
                <tr>
                  <td colSpan={5}>No promo codes yet.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="ops-override-form mt-4">
          <div className="ops-overrides-header">
            <div>
              <h5>{editingPromoId ? "Edit Promo" : "Create Promo"}</h5>
              <p>Configure benefit payloads for automated overrides.</p>
            </div>
            {editingPromoId && (
              <button type="button" className="btn btn-link" onClick={resetPromoForm}>
                Clear
              </button>
            )}
          </div>
          <div className="ops-two-col">
            <label>
              Code
              <input
                type="text"
                value={promoForm.code}
                onChange={(e) => handlePromoField("code", e.target.value.toUpperCase())}
                placeholder="E.g. FRIENDS50"
              />
            </label>
            <label>
              Description
              <input type="text" value={promoForm.description} onChange={(e) => handlePromoField("description", e.target.value)} />
            </label>
            <label>
              Max Redemptions
              <input
                type="number"
                min="0"
                value={promoForm.maxRedemptions}
                onChange={(e) => handlePromoField("maxRedemptions", e.target.value)}
                placeholder="0 = unlimited"
              />
            </label>
            <label>
              Per Company Limit
              <input
                type="number"
                min="1"
                value={promoForm.perCompanyLimit}
                onChange={(e) => handlePromoField("perCompanyLimit", e.target.value)}
              />
            </label>
            <label>
              Valid From
              <input
                type="datetime-local"
                value={promoForm.validFrom}
                onChange={(e) => handlePromoField("validFrom", e.target.value)}
              />
            </label>
            <label>
              Valid Until
              <input
                type="datetime-local"
                value={promoForm.validUntil}
                onChange={(e) => handlePromoField("validUntil", e.target.value)}
              />
            </label>
            <label className="checkbox-field">
              <input type="checkbox" checked={promoForm.isActive} onChange={(e) => handlePromoField("isActive", e.target.checked)} />
              Active
            </label>
          </div>

          <div className="benefit-grid">
            <label>
              Plan Name
              <input
                type="text"
                value={promoForm.benefits.customPlanName}
                onChange={(e) => handlePromoBenefitField("customPlanName", e.target.value)}
              />
            </label>
            <label>
              Device Limit
              <input
                type="number"
                value={promoForm.benefits.devicesAllowed}
                onChange={(e) => handlePromoBenefitField("devicesAllowed", e.target.value)}
              />
            </label>
            <label>
              User Limit
              <input
                type="number"
                value={promoForm.benefits.usersAllowed}
                onChange={(e) => handlePromoBenefitField("usersAllowed", e.target.value)}
              />
            </label>
            <label>
              SMS Quota
              <input
                type="number"
                value={promoForm.benefits.smsQuota}
                onChange={(e) => handlePromoBenefitField("smsQuota", e.target.value)}
              />
            </label>
            <label>
              Voice Quota
              <input
                type="number"
                value={promoForm.benefits.voiceQuota}
                onChange={(e) => handlePromoBenefitField("voiceQuota", e.target.value)}
              />
            </label>
            <label>
              Price Override
              <input
                type="number"
                step="0.01"
                value={promoForm.benefits.priceOverride}
                onChange={(e) => handlePromoBenefitField("priceOverride", e.target.value)}
              />
            </label>
            <label>
              Discount %
              <input
                type="number"
                step="0.1"
                value={promoForm.benefits.discountPercent}
                onChange={(e) => handlePromoBenefitField("discountPercent", e.target.value)}
              />
            </label>
            <label>
              Duration (days)
              <input
                type="number"
                value={promoForm.benefits.durationDays}
                onChange={(e) => handlePromoBenefitField("durationDays", e.target.value)}
                placeholder="Generate expiry from redemption date"
              />
            </label>
            <label>
              Fixed Expiry
              <input
                type="datetime-local"
                value={promoForm.benefits.expiresAt}
                onChange={(e) => handlePromoBenefitField("expiresAt", e.target.value)}
              />
            </label>
          </div>
          <label>
            Benefit Notes
            <textarea rows={3} value={promoForm.benefits.note} onChange={(e) => handlePromoBenefitField("note", e.target.value)} />
          </label>

          <div className="ops-button-row">
            <button type="button" className="btn btn-primary" onClick={savePromo} disabled={promoLoading}>
              {promoLoading && editingPromoId ? "Updating..." : promoLoading ? "Saving..." : "Save Promo"}
            </button>
            <button type="button" className="btn btn-outline-secondary" onClick={resetPromoForm}>
              Reset Form
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
